@if (errorImportLogItem.errorCode === 'COLUMNS_MISSING') {
  <span>
    Es wurden ein oder mehrere erforderliche Spalten (<i>{{formatArray(errorImportLogItem.objects)}}</i>)
    im Excel nicht gefunden. Bitte ändern Sie keinesfalls eigenständig die Namen.
  </span>
}

@if (errorImportLogItem.errorCode === 'GENERAL_PARSING_ERROR') {
  <span>
    Es ist nicht spezifizierter Fehler beim Parsen des Excel-Dokuments aufgetreten.
    Bitte verwenden Sie das Dokument, das Sie über den Erzeugungsanlagen-Export erhalten.
  </span>
}

@if (errorImportLogItem.errorCode === 'INCONVERTIBLE_STREAM') {
  <span>
    Das hochgeladene Dokument wurde nicht als Excel erkannt. Bitte erstellen Sie nicht eigenständig
    das Dokument, sondern verwenden das Dokument, das Sie über den Erzeugungsanlagen-Export erhalten.
  </span>
}

@if (errorImportLogItem.errorCode === 'UNKNONW_ERROR') {
  <span>
    Es ist ein unbekannter Fehler aufgetreten. Möglicherweise wurden in der Zeit zwischen Prüfung und
    Importvorgang die Daten im Hintergrund verändert. Bitte starten Sie den Importvorgang erneut. Falls der
    Fehler immer noch auftritt, wenden Sie sich bitte an den Support.
  </span>
}
